import React from 'react';
import PropTypes from 'prop-types';
import { squashString } from 'ggtmo-utils';

// Components
import TableCell from '@material-ui/core/TableCell';
import MatTable from '../../../../shared/components/table/MatTable';

const tableColumns = [
  {
    id: 'name', label: 'Name', disablePadding: false, numeric: false, align: 'left',
  },
  {
    id: 'Rent Account Number', label: 'Rent Account Number', disablePadding: false, numeric: false, align: 'left',
  },
];

const TableRow = ({
  user: {
    name,
  },
  rentAccountNumber,
}) => (
  <>
    <TableCell className="material-table__cell">
      {squashString(name, { length: 80 })}
    </TableCell>
    <TableCell className="material-table__cell">
      {rentAccountNumber}
    </TableCell>
  </>
);

TableRow.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  rentAccountNumber: PropTypes.string.isRequired,
};

const ResidentsTable = ({
  children,
  selected,
  residents,
  page,
  count,

  // Callbacks
  onSelect,
  onPageChange,
}) => (
  <div>
    <MatTable
      rowComponent={TableRow}
      columns={tableColumns}
      data={residents}
      selected={selected}
      page={page}
      count={count}

      // Callbacks
      onSelect={onSelect}
      onPageChange={onPageChange}
    >
      {children}
    </MatTable>
  </div>
);

ResidentsTable.propTypes = {
  children: PropTypes.node,
  residents: PropTypes.instanceOf(Array).isRequired,
  selected: PropTypes.instanceOf(Array).isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,

  // Callbacks
  onSelect: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

ResidentsTable.defaultProps = {
  children: null,
};

export default ResidentsTable;
